<template>
  <div class="price__nav flex flex--justify-center">
    <div class="price__cards-nav flex flex--justify-center">
      <button
        class="price__card-nav-item"
        @click="handleMode('monthly')"
        :class="{ active: opts.mode === 'monthly' }"
      >
        Monthly
      </button>
      <button
        class="price__card-nav-item"
        @click="handleMode('annual')"
        :class="{ active: opts.mode === 'annual' }"
      >
        Annual <span class="price__card-annual">Save -9%</span>
      </button>
    </div>
    <div class="price__currency">
      <div
        class="select"
        :class="{ active: showSelect }"
        @click="handleCloseSelect"
      >
        <div class="select__head" @click.stop="showSelect = !showSelect">
          <div
            class="select__item select__item--selected"
            v-text="opts?.currency"
          ></div>
        </div>
        <div class="select__list">
          <div class="select__item" @click="handleCurrencyComponent('$ USD')">
            $ USD
          </div>
          <div class="select__item" @click="handleCurrencyComponent('€ EUR')">
            € EUR
          </div>
          <div class="select__item" @click="handleCurrencyComponent('£ GBP')">
            £ GBP
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PriceNavigation",
  props: ["opts"],
  inject: ["handleCurrency", "handleMode"],
  data() {
    return {
      showSelect: false,
      calculator: null,
    };
  },

  created() {
    window.addEventListener("click", this.handleCloseSelect);
    this.calculator = window.Calculator;
  },
  methods: {
    handleCloseSelect(e) {
      this.showSelect = false;
    },
    handleCurrencyComponent(currency) {
      this.calculator.handleCurrency(currency.split(" ")[0]);
      this.handleCurrency(currency);
    },
  },

  beforeDestroy() {
    window.removeEventListener("click", this.handleCloseSelect);
  },
};
</script>

<style scoped></style>
